// Carved verbatim from `src/features/agent-harness/hooks.ts` (ARCFE-1079 · D4).
// `transport` is REQUIRED here — see `query/useQueryRun.ts` for why the
// `agentHarnessClient` default stays app-side.
//
// NOT the same hook as `mutation/useResolveApproval.ts`: this one drives the
// RunTransport-shaped resolve the harness timeline uses (and invalidates the
// run snapshot); that one is the inline-clarification ceremony over the
// `/agents/runs/{id}/approvals/{approvalId}:resolve` REST fn (and invalidates
// the inbox). Both names predate the carve and both keep them.
import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ResolveApprovalRequest } from '../../contracts/harness.types';
import { agentHarnessKeys } from '../../contracts/keys';
import type { RunTransport } from '../../contracts/transport';

export const useMutateResolveApproval = (transport: RunTransport) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      agentRunId,
      approvalId,
      body,
    }: {
      agentRunId: string;
      approvalId: string;
      body: ResolveApprovalRequest;
    }) => transport.resolveApproval(agentRunId, approvalId, body),
    onSuccess: (_data, { agentRunId }) => {
      void queryClient.invalidateQueries({
        queryKey: agentHarnessKeys.run(agentRunId),
      });
    },
  });
};
